import ReceiptNumber from './ReceiptNumber'
import RepresentativeUser from './RepresentativeUser'
import SecondCopyReceiveDate from './SecondCopyReceiveDate'
import ThirdCopyReceiveDate from './ThirdCopyReceiveDate'

export const labels = {
  ReceiptNumber: 'Bizonylatszám',
  RepresentativeUser: 'Képviselő',
  SecondCopyReceiveDate: 'Második másolat beérkezés',
  ThirdCopyReceiveDate: 'Harmadik másolat beérkezés',
};

export const allColumns = [
  {
    value: 'ReceiptNumber'
  },
  {
    value: 'RepresentativeUser'
  },
  {
    value: 'SecondCopyCreatorUserName'
  },
  {
    value: 'ThirdCopyCreatorUserName',
  },
  {
    value: 'SecondCopyReceiveDate'
  },
  {
    value: 'ThirdCopyReceiveDate'
  }
];

export const defaultColumns = [
  {
    value: 'ReceiptNumber'
  },
  {
    value: 'RepresentativeUser'
  },
  {
    value: 'SecondCopyReceiveDate'
  },
  {
    value: 'ThirdCopyReceiveDate'
  }
];

export const defaultSort = {
  prop: ReceiptNumber.propName,
  order: 'descending'
};

export default {
  ReceiptNumber,
  RepresentativeUser,
  SecondCopyReceiveDate,
  ThirdCopyReceiveDate
};
